import {ApplicationConfigVarNames} from '../../entry-routes/configuration/application-config-var-names';
import {ConfigurationService} from '../../entry-routes/configuration/configuration.service';

export class Url {
  // services
  static readonly ADMIN_CLI = 'admin';

  // public urls
  static readonly PUBLIC_API = 'public/';
  static readonly SUPPORT_API = 'support/';

  static readonly LOGIN = 'login/';


  // protected urls
  static readonly PROTECTED_API = 'rest/';
  static readonly PROCESS_INSTANCE = 'process-instance/';
  static readonly ENGINE_REST = 'engine-rest/';

  static readonly DOCUMENTS = 'documents/';
  static readonly DOCUMENT = 'document/';
  static readonly TASKS = 'tasks/';
  static readonly SUPERVISION_PARAMS= 'supervision-params'
  static readonly SUPERVISION = 'supervision/';
  static readonly TASK = 'task/';
  static readonly DETAILS = 'details/';
  static readonly DELETE = 'delete/';
  static readonly SEARCH = 'search/';
  static readonly AGGS = 'aggs/';
  static readonly LINKS = 'entities/';
  static readonly ENTITY = 'entity/';
  static readonly PARENT_ENTITIES = 'parentEntities/';
  static readonly PARENT_DOCUMENT = 'parentOf/';
  static readonly CHILDREN_DOCUMENT = 'childrenOf/';
  static readonly LINKED = 'linked/';
  static readonly COMMENTS = 'comments/';
  static readonly COMMENTS_FILE = 'commentedPdf/';
  static readonly REPLY = 'reply/';
  static readonly ATTACHMENT = 'attachments/';
  static readonly HISTORY = 'activities/';
  static readonly FILE = 'file/';
  static readonly ZIP = 'zip/';
  static readonly TO_EXCEL = 'document/excel/';
  static readonly FORMATS = 'formats/';
  static readonly THUMB = 'thumb/';
  static readonly DOCUMENT_PDF = 'view/';
  static readonly INDEXATION = 'indexations/';
  static readonly MULTIPLE = 'multiple/';
  static readonly DRAFT = 'drafts/';
  static readonly INDEXATION_PDF = 'view/';
  static readonly INDEXATION_FILE = 'file/';
  static readonly INDEXATION_DOC_TYPE = 'docTypes/';
  static readonly UTILS = 'utils/';
  static readonly RULES_TEST = 'rules/test';
  static readonly TO_PDF = 'toPdf/';
  static readonly VIEW = 'views/';
  static readonly RECAP = 'recap/';
  static readonly ENTITY_RECAP = 'recap/entities/';
  static readonly DOMAINS = 'domains/';
  static readonly INFOS = 'documents/info/';
  static readonly FIELDS = 'fields/';
  static readonly LIST = 'list/';
  static readonly LIST_ITEM = 'listItem/';
  static readonly LOTS = 'indexEntities/';
  static readonly DOC_TYPES = 'documentTypes/';
  static readonly AGGREGATES = 'aggregates/';
  static readonly SEARCH_LIST = 'searchList';
  static readonly USERS = 'users/';
  static readonly NEXIA_USERS = 'nexiaUsers/';
  static readonly THESAURUS = 'thesaurus/';
  static readonly ITEMS = 'items/';
  static readonly CHILDREN = 'children/';
  static readonly TEAMS = 'teams/';
  static readonly MY_TEAMS = 'myteams/';
  static readonly DUPLICATE = 'duplicate/';
  static readonly EXISTS = 'exists/';
  static readonly PARAMS = 'params/';
  static readonly MENU = 'menu';
  static readonly HISTORY_EVT_REV = 'history/';
  static readonly REVISIONS = 'revisions/';
  static readonly COUNTERS = 'counters/';
  static readonly PARTICIPANTS = 'participants/';
  static readonly QUESTION_TO = 'question_to/';
  static readonly EXCEL = 'excel';

  static readonly AUTOCOMPLETE_KEYWORD = 'autocomplete/keyword/';
  static readonly AUTOCOMPLETE_VALUE = 'autocomplete/value/';
  static readonly AUTOCOMPLETE_KEY_VALUE = 'autocomplete/keywordValue/';
  static readonly AUTOCOMPLETE_AGGREGATE = 'autocomplete/aggregate/';
  static readonly FOLDERS = 'folders/';
  static readonly CUSTOM_LINKS = 'custlinks/';
  static readonly ACTIONS = 'actions/';
  static readonly RESTORE_REVISION = 'restoreRevision/';

  static readonly RUNTIME_TASKS = 'runtime/tasks/';
  static readonly FORM_VARIABLES = 'form-variables/';
  static readonly VARIABLES = 'variables/';
  static readonly COMPLETE = 'complete/';
  static readonly CLAIM = 'claim/';

  //static readonly WKF_TASK_FORM = 'app/rest/task-forms/';
  static readonly WKF_IDM_USERS = 'nexia-api/idm/users';
  static readonly WKF_TASK = 'nexia-api/runtime/task/';
  static readonly WKF_TASK_BULK_COMPLETE = 'bulkComplete/';

  static readonly WKF_TASK_HISTORY = 'nexia-api/runtime/task/history/';
  static readonly WKF_TASK_FORM = 'nexia-api/runtime/task-forms/';
  static readonly WKF_SAVE_FORM = "save-form"
  static readonly WKF_PROCESS_API = 'process-api';
  static readonly WKF_NEXIA_API = "nexia-api";
  static readonly WKF_NEXIA_API_TEMPLATES = "templates";
  static readonly WKF_FILE_MERGE = "file/merge";

  static readonly WKF_WKFLINKEDPROCESSUSINSTANCESFROMPROCESSINSTANCEID = "wkfLinkedProcessusInstancesFromProcessInstanceId";
  static readonly WKF_PROCESS = "process/"
  static readonly WKF_LAST_TASK = "/lasttask"
  static readonly WKF_FORM = "/form"

  static readonly DELEGATIONS="/delegations"
  static readonly DELEGATIONS_CANCEL="/cancel"
  static readonly DELEGATIONS_ACTIVATE="/activate"
  static readonly DELEGUE="/delegue"
  static readonly USER_PROFILE="/user-profile"
  static readonly USER_SUPERVISED="/user/supervised"

  static readonly LOCK = 'lock/';
  static readonly METADATA = 'metadata';
  static readonly ALERTS = 'alerts/';
  static readonly ALERTS_ACTIVATE = 'activate';
  static readonly ALERTS_DEACTIVATE = 'deactivate';
  static readonly ALERT_TYPES = 'alertTypes/'
  static readonly COUNTER_TYPES = 'counterTypes/'

  static readonly TECHBI = 'integrations/techbi/';
  static readonly IDP = 'integrations/idp/';

  static readonly CONTACT_TYPE = 'contactType/';
  static readonly CONTACTS = 'contacts/';
  static readonly HOTJAR_JS_BASE_URL = 'https://t.contentsquare.net/uxa/';

  static getWkfProtectedApiBaseUrl(configService: ConfigurationService): string {
    return !configService.isWorkflowEnabled() ? null : `${this.getWkfApiBaseUrl(configService)}${Url.WKF_NEXIA_API}/`;
  }

  static getFlowableProtectedApiBaseUrl( configService: ConfigurationService): string {
    return !configService.isWorkflowEnabled() ? null : `${this.getWkfApiBaseUrl(configService)}`;
  }

  static getProtectedApiBaseUrl(configService: ConfigurationService): string {
    return `${this.getApiBaseUrl(configService)}${Url.PROTECTED_API}`;
  }

  static getSupportApiBaseUrl(configService: ConfigurationService): string {
    return `${this.getApiBaseUrl(configService)}${Url.SUPPORT_API}`;
  }

  static getAdminFrontBaseUrl(configService: ConfigurationService): string {
    return `${configService.getConfigVariable(ApplicationConfigVarNames.API_BACK_URL)}/${Url.ADMIN_CLI}`;
  }


  static getApiBackUrl(configService: ConfigurationService): string {
    return `${configService.getConfigVariable(ApplicationConfigVarNames.API_BACK_URL)}`;
  }

  private static getApiBaseUrl(configService: ConfigurationService): string {
    let backName: string = configService.getConfigVariable(ApplicationConfigVarNames.API_BACK_NAME) || '';
    if (backName && !backName.endsWith('/')) {
      backName += '/';
    }
    return `${configService.getConfigVariable(ApplicationConfigVarNames.API_BACK_URL)}/${backName}`;
  }

  private static getWkfApiBaseUrl(configService: ConfigurationService): string {
    if (!configService.isWorkflowEnabled()) {
      return null;
    }
    let backName: string = configService.getConfigVariable(ApplicationConfigVarNames.WKF_API_BACK_NAME) || '';
    if (backName && !backName.endsWith('/')) {
      backName += '/';
    }
    return `${configService.getConfigVariable(ApplicationConfigVarNames.WKF_API_BACK_URL)}/${backName}`;
  }
}
